import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const get = (query) => axios.get(toQueryString(`/api/v1/legal-documents?`, query));

const getById = (id, query) => axios.get(toQueryString(`/api/v1/legal-documents/${id}?`, query));

const publish = (id, params) => axios.put(`/api/v1/legal-documents/${id}/publish`, params);

const discard = (id, params) => axios.put(`/api/v1/legal-documents/${id}/discard`, params);

const update = (id, body) => axios.put(`/api/v1/legal-documents/${id}`, body);

const ApiLegalDocuments = {
  get,
  getById,
  publish,
  discard,
  update
};

export default ApiLegalDocuments;
